<div class="multi-select-dropdown-container">
  <div
    class="dropdown-display"
    (click)="toggleDropdown($event)"
    tabindex="0"
    (keydown.enter)="toggleDropdown($event)"
  >
    <div class="dropdown-placeholder-wrapper">
      <span class="dropdown-label" [class.floating]="selectedItems.length">
        {{ placeHolder || 'Filter' }}
      </span>

      <div class="dropdown-selected">
        <!-- Show summary instead of infinite chips -->
        <span *ngIf="selectedItems.length === 0"></span>

        <span *ngIf="selectedItems.length === 1">
          {{ selectedItems[0].key }}
        </span>

        <span *ngIf="selectedItems.length > 1">
          {{ selectedItems.length }} selected
        </span>

        <!-- Clear button -->
        <button
          *ngIf="selectedItems.length"
          class="clear-btn"
          (click)="clearAll($event)"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <button class="dropdown-arrow-btn">
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
  </div>

  <div *ngIf="dropdownVisible" class="dropdown-list">
    <div class="search-bar">
      <input
        type="search"
        placeholder="Search and Press Enter"
        [formControl]="searchControl"
      />
    </div>

    <div class="list-items">
      <ul *ngIf="filteredItems.length; else noData">
        <li *ngFor="let item of filteredItems" class="list-item">
          <label class="checkbox-item">
            <input
              type="checkbox"
              [checked]="isSelected(item)"
              (change)="onItemToggle(item)"
            />
            {{ item.key }}
          </label>
        </li>
      </ul>

      <ng-template #noData>
        <img
          class="no-data-img"
          src="../../assets/dataNotFound.jpg"
          alt="No Data"
        />
      </ng-template>
    </div>
    <div class="dropdown-actions">
      <button class="btn-clear" (click)="clearAll($event)">Clear</button>
      <button class="btn-done" (click)="applySelection($event)">Done</button>
    </div>
  </div>
</div>
